export const ABSTRACT_DROPDOWN_TOGGLE_ID_PREFIX = 'dropdown-toggle:';
export const ABSTRACT_DROPDOWN_ITEM_ID_PREFIX = 'dropdown-item:';
export const ABSTRACT_DROPDOWN_MENU_ID_PREFIX = 'dropdown-menu:';
